import { Controller } from "stimulus";

export default class AddButtonComponent extends Controller {
  connect() {
    this.setupButtonColorCyle();
  }

  // Cycle between common podcast icon colors (fuscia-600->green-500->orange-500) every 2 seconds
  setupButtonColorCyle() {
    const colors = this.colorsValue.split(",");
    const ringColors = this.ringColorsValue.split(",");

    if (colors.length > 1) {
      let colorIndex = 0;
      setInterval(() => {
        this.buttonOuterRingTarget.classList.remove(ringColors[colorIndex]);
        this.buttonTarget.classList.remove(colors[colorIndex]);
        colorIndex = (colorIndex + 1) % colors.length;
        this.buttonOuterRingTarget.classList.add(ringColors[colorIndex]);
        this.buttonTarget.classList.add(colors[colorIndex]);
      }, 2000);
    }
  }
}

AddButtonComponent.targets = ["button", "buttonOuterRing", "default", "loading", "done"];
AddButtonComponent.values = {
  colors: String,
  ringColors: String,
};
